import PropTypes from 'prop-types';
import { Component, useState, useEffect } from 'react';
import { ReactSVG } from 'react-svg';
import classNames from 'classnames';
import { parseApiError } from '@yooink/youtils/es/ErrorHandler';

import './Autorizaion.less';

import Container from 'reactstrap/es/Container';
import Label from 'reactstrap/es/Label';
import Input from 'reactstrap/es/Input';
import Button from 'reactstrap/es/Button';
import { UserContext } from '../../../../Components/UserContext';
import warning from '../../../../Images/warning.svg';

import backgound from './background.jpg';
import { getAvatarUrl } from '../../chizhart/Layout/sidebar/GetAvatarUrl';
import Spinner from 'reactstrap/es/Spinner';

function ErrorLabel ({ isShow, message }) {
	if (!isShow) return null;
	return (
		<div className="alert_warning">
			<div className="alert_warning-icon">
				<ReactSVG src={warning} />
			</div>
			<div className="alert_warning-info">
				<div className="alert_warning-body">{message}</div>
			</div>
		</div>
	);
}

function CacheUser ({ user, onReset }) {
	return (
		<div className="auth-remember-user">
			<img
				alt="Мой аватар"
				className="avatar"
				src={user.avatar}
			/>
			<h5>
				{user.fullName}
			</h5>
			<Button
				block
				color="link"
				size="sm"
				onClick={onReset}
			>
				Не вы?
			</Button>
		</div>
	);
}

function PreloadImg ({ preloader, src }) {
	const [_src, setSrc] = useState(preloader);
	useEffect(() => {
		const img = new Image();
		img.src = src;
		img.addEventListener('load', () => setSrc(src));
	}, [src]);
	return <img src={_src} />;
}

class AuthPage extends Component {
	static contextType = UserContext;

	state = {
		errors: {}
	};

	loadUserFromCache = (data) => this.setState({
		hasCache: true,
		username: data.username,
		cache: data,
		skipPassword: !data.authCriteria ? false : !data.authCriteria.password
	});

	componentDidMount () {
		window.document.title = 'Пройдите авторизацию';
		const cachedUser = window.localStorage.getItem('cachedUser');
		if (cachedUser) {
			const data = JSON.parse(cachedUser);
			this.loadUserFromCache(data);
		}
	}

	tryAuth = async (e) => {
		e?.preventDefault();
		if(e.ctrlKey && !this.state.password) return this.context.beginSSO();
		try {
			let isInvalidForm = false;
			const errors = {};
			if (!this.state.username) {
				errors.username = true;
				isInvalidForm = true;
			}
			if (!this.state.skipPassword) {
				if (!this.state.password) {
					errors.password = true;
					isInvalidForm = true;
				}
			}
			if (isInvalidForm) {
				return this.setState({
					errors
				});
			}
			await this.setState({ isError: false, disabled: true });
			const { user, requiredTotp, authCriteria } = await this.context.logIn({
				username: this.state.username,
				password: this.state.password,
				token: this.state.totpToken
			});
			const userCache = {
				username: this.state.username,
				avatar: getAvatarUrl(user),
				fullName: user.fullName,
				authCriteria
			};
			window.localStorage.setItem('cachedUser', JSON.stringify(userCache));
			await this.loadUserFromCache(userCache);
			if (requiredTotp) {
				await this.setState({
					requiredTotp: true,
					skipPassword: true,
					disabled: false
				});
			}
		} catch (e) {
			await this.setState({
				isError: true,
				errMessage: parseApiError(e),
				disabled: false
			});
			if (e.body?.resetCache) await this.resetCache();
			throw e;
		}
	};

	resetCache = () => {
		this.setState({
			hasCache: false,
			username: '',
			cache: null,
			skipPassword: false,
			requiredTotp: false
		}, () => window.localStorage.removeItem('cachedUser'));
	};

	render () {
		return (
			<Container className="gate_container-body" fluid>
				<div className="gate_avatar">
					<PreloadImg
						src={window.localStorage?.getItem('settings.ui.authPage.loremService') ??
							`https://loremflickr.com/1920/1080/${window.localStorage?.getItem('settings.ui.authPage.loremTheme')?? 'datacenter'}`
						}
						preloader={backgound}
					/>
				</div>
				<div className="gate_container">
					<div className="gate_passport">
						<h3 className="gate_passport-name">Вход</h3>
						{/* <p className="gate_passport-text">
							Авторизируйтесь, что бы зайти в панель управления
						</p> */}
						<div className="passport_form">

							{this.state.hasCache ? <CacheUser user={this.state.cache} onReset={this.resetCache} /> : (
								<>
									<div className="form-group passport_form-group">
										<Label htmlFor="login">Логин</Label>
										<Input
											disabled={this.state.disabled}
											name="username"
											value={this.state.username}
											placeholder="Введите логин"
											className={classNames('form-control', { error: this.state.isError || this.state.errors?.username })}
											onChange={(e) => this.setState({
												username: e.target.value,
												errors: {
													...this.state.errors,
													username: false
												}
											})}
										/>
										<ErrorLabel isShow={this.state.errors?.username} message="Введите логин" />
										<ErrorLabel isShow={this.state.isError} message={this.state.errMessage} />
									</div>
								</>
							)}
							{!this.state.skipPassword && (
								<div className="form-group passport_form-group">
									<Label htmlFor="password">Пароль</Label>
									<Input
										disabled={this.state.disabled}
										placeholder="Ваш пароль"
										type="password"
										name="password"
										value={this.state.password}
										className={classNames('form-control', { error: this.state.isError || this.state.errors?.password })}
										onChange={(e) => this.setState({
											password: e.target.value,
											errors: {
												...this.state.errors,
												password: false
											}
										})}
										onKeyPress={(e) => {
											if (e.key === 'Enter') {
												this.tryAuth();
											}
										}}
									/>
									<ErrorLabel isShow={this.state.errors?.password} message="Введите пароль" />
									{this.state.hasCache && <ErrorLabel isShow={this.state.isError} message={this.state.errMessage} />}
								</div>
							)}
							{this.state.requiredTotp && (
								<div className="form-group passport_form-group">
									<Label htmlFor="password">Код двухфакторной авторизации</Label>
									<Input
										disabled={this.state.disabled}
										placeholder="123456"
										type="number"
										name="otp"
										value={this.state.totpToken}
										className={classNames('form-control', { error: this.state.isError || this.state.errors?.totpToken })}
										onChange={(e) => this.setState({
											totpToken: e.target.value,
											errors: {
												...this.state.errors,
												totpToken: false
											}
										})}
										onKeyPress={(e) => {
											if (e.key === 'Enter') {
												this.tryAuth();
											}
										}}
									/>
									<ErrorLabel isShow={this.state.errors?.totpToken} message="Код двухфакторной авторизации" />
								</div>
							)}
							<Button
								disabled={this.state.disabled}
								className="gate_passport-button"
								onClick={this.tryAuth}
								block
							>
								{this.state.disabled ? (
									<Spinner />
								) : 'Войти'}
							</Button>
							<Button
								block
								color={'link'}
								onClick={() => this.context.beginSSO()}
							>
								Войти через SSO
							</Button>
						</div>
					</div>
				</div>
			</Container>
		);
	}
}

export default AuthPage;

ErrorLabel.propTypes = {
	isShow: PropTypes.bool.isRequired,
	message: PropTypes.string.isRequired
};
